export default __webpack_public_path__ + "static/media/laptopPlaceholder.ef18bcff.svg";